
import { CheckCheck, X } from 'lucide-react';
import UILoaderUnified from '@/components/UILoaderUnified';


interface AILoadingIndicatorProps {
  modelName: string;
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
  isDarkMode: boolean;
  contextOverride?: 'image' | 'chat-agent' | 'chat-model' | 'web-search' | 'deep-research' | 'quiz';
  nameOverride?: string;
  userQuery?: string;
}

export const AILoadingIndicator = ({
  modelName,
  isLoading,
  isError,
  errorMessage,
  isDarkMode,
  contextOverride,
  nameOverride,
  userQuery,
}: AILoadingIndicatorProps) => {
  if (!isLoading && !isError) return null;

  return (
    <div className={`inline-flex items-center gap-3 px-4 py-2 rounded-lg transition-all duration-300 ${isError
      ? isDarkMode
        ? 'bg-red-900/20 border-red-600/30 text-red-400'
        : 'bg-red-50 border-red-300 text-red-700'
      : isDarkMode
        ? ''
        : ''
      }`}>
      <div className="flex items-center gap-2">
        {isLoading && !isError && (
          <UILoaderUnified
            key="loader-fixed"
            isDarkMode={isDarkMode}
            context={contextOverride || (modelName === 'agent' ? 'chat-agent' : 'chat-model')}
            name={nameOverride || modelName}
            userQuery={userQuery || (localStorage.getItem('currentQuery') || undefined)}
          />
        )}
        {!isLoading && !isError && (
          <CheckCheck className="w-4 h-4 text-blue-500" />
        )}
        {isError && (
          <X className="w-4 h-4 text-red-500" />
        )}
      </div>
      {isError && errorMessage && (
        <span className="text-xs opacity-80 ml-2">
          {errorMessage.length > 50 ? errorMessage.substring(0, 50) + '...' : errorMessage}
        </span>
      )}
    </div>
  );
};
